import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4f6e1460"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftsno%2Ffrechdax%2Fabdl-party%2Fweb%2Fwebapp%2Fsrc%2Fcomponents%2Fnewsletter%2F2024.01%2Findex.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "@/locales/global.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Ftsno%2Ffrechdax%2Fabdl-party%2Fweb%2Fwebapp%2Fsrc%2Fcomponents%2Fnewsletter%2F2024.01%2Findex.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports